import { render, staticRenderFns } from "./selectCustomer.vue?vue&type=template&id=2643940a"
import script from "./selectCustomer.vue?vue&type=script&lang=js"
export * from "./selectCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports